import React from "react";
import ElementPropertiesWrapper from "./ElementPropertiesWrapper";

// todo: remove this maybe?
const ElementsProperties = (props) => (
  <ElementPropertiesWrapper {...props} />
);

export default ElementsProperties;
